"use strict";
// @ts-ignore
try {
    self['workbox:strategies:5.1.3'] && _();
}
catch (e) { }
